import { render, staticRenderFns } from "./common.vue?vue&type=template&id=319a49a3&scoped=true"
import script from "./common.vue?vue&type=script&lang=ts"
export * from "./common.vue?vue&type=script&lang=ts"
import style0 from "./common.vue?vue&type=style&index=0&id=319a49a3&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "319a49a3",
  null
  
)

export default component.exports